import React from 'react';
import { useLocation } from 'react-router-dom';
import Staff from './Staff';
import StaffView from './StaffView';
import StaffEdit from './StaffEdit';
import DashboardScreen from './DashboardScreen';

const TeachersRouteWrapper = ({ isEdit = false }) => {
  const location = useLocation();
  const teacherData = location.state?.teacherData;

  return (
    <DashboardScreen>
      {isEdit ? (
        <StaffEdit teacherData={teacherData} />
      ) : (teacherData || location.pathname.split('/').pop() !== 'staff' && location.pathname.split('/').pop() !== '') ? (
        <StaffView teacherData={teacherData} />
      ) : (
        <Staff />
      )}
    </DashboardScreen>
  );
};

export default TeachersRouteWrapper;
